<template>
  <div class="modal rounded" :class="{'has-description': content.description}">
    <img :src="content.image" :title="content.name" />
    <div v-if="content.description" v-html="content.description" class="description"></div>
  </div>
</template>

<script>
import { modalMixin } from '@/mixins/modalMixin.js'
export default {
  name: 'image-modal',
  mixins: [modalMixin],
  mounted() {
  }
}
</script>

<style lang="scss" scoped>
.modal {
  
  img {
    flex: 1;
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
  }
  &.has-description {
    display: flex;
    img {
      flex: 1;
      max-width: 724px;
    }
  }
  .description {
    flex: 1;
    max-width: 300px;
    padding: 20px;
  }
}
</style>